export function formatAddress(...params) {
  const formattedAddress = params.filter((param) => param && param.trim() !== '').join(', ');
  return formattedAddress === '' ? null : formattedAddress;
}
